import QRCode from 'react-qr-code';
import { invitePreviewUrl } from '@peles/shared';
import type { InviteRecipient } from '@peles/shared';
import { EntityModal } from '../../common';

export interface RecipientQrModalProps {
  recipient: InviteRecipient | null;
  onClose: () => void;
}

/**
 * A guest's invitation as a QR code — the same `/i/` link the share buttons
 * hand out, which the check-in scanner also reads at the door.
 */
export function RecipientQrModal({ recipient, onClose }: RecipientQrModalProps) {
  const url = recipient ? invitePreviewUrl(window.location.origin, recipient.token) : '';
  return (
    <EntityModal
      open={!!recipient}
      onClose={onClose}
      title={recipient?.guestName ?? 'Invitation QR code'}
      size="xs"
      presentation="centered"
    >
      {recipient && (
        <div className="flex flex-col items-center gap-3 py-2">
          <div className="rounded-xl bg-white p-3 theme-light">
            <QRCode value={url} size={192} aria-label="Invitation QR code" />
          </div>
          <p className="break-all text-center text-xs text-gray-500">{url}</p>
          <p className="text-center text-xs text-gray-400">
            Scan to open the invitation — also used for check-in at the door.
          </p>
        </div>
      )}
    </EntityModal>
  );
}
